
<div>
  <div class="d-flex justify-content-between mb-3">
    <div class="title">Attachments</div>
    <div class="d-flex">
      <button class="mr-2 btn btn-info btn-sm" @click="downloadAllAttachments" v-if="userCanEdit && (attachments.length || boardsWithAttachments.length)">
        <i class="far fa-download icon-left mr-2"></i>
        Download all Attachments
      </button>
      <UploadAttachment v-if="userCanEdit" :isSmallButton="true" :label="'Add Attachment'" :destination="'SpecialOccurrence'" :destinationId="occId" />
    </div>
  </div>
  <div v-if="attachments.length === 0">
    Currently there are no files attached to this Special Occurrence. To add a file click on "Add Attachment"
  </div>
  <AttachmentView :header="''" :destinationId="occId" :destination="'SpecialOccurrence'" :attachments="attachments" :read-only="!userCanEdit" />

  <div class="title mb-4 mt-4" v-if="boardsWithAttachments.length">Attachments from Tasks</div>

  <div v-for="board of boardsWithAttachments" :key="board.boardId">
    <div class="title mb-3">{{board.boardTitle}}</div>
    <div v-for="item of board.items.filter(_ =>_.attachments.length)" :key="item.id">
      <div class="row mb-4">

        <div class="col-8">
          <AttachmentView :header="''" :canDelete="false" :destinationId="occId" :destination="'SpecialOccurrence'" :attachments="item.attachments" />
        </div>
        <div class="col-3">
          <task-card :item="item" :isSO="true" :minimal="true"></task-card>
        </div>
      </div>
      <hr>
    </div>
  </div>
  <router-view></router-view>
</div>
